import { Tab } from 'react-tabs';
import styled, { css } from 'styled-components/macro';
import theme from 'styles/theme';

const tabUnderLine = css`
  &::after {
    content: '';
    display: block;
    height: 3px;
    margin: 0 auto;
    border-radius: 8px;
    background-color: ${theme.tabUnderline};
  }
`;

const StyledTab = styled(Tab)`
  ${tabUnderLine}
  display: inline-block;
  flex: 1;
  height: 48px;
  color: ${theme.textPrimary};
  font-size: 14px;
  font-weight: bold;
  line-height: 48px;
  text-align: center;
  cursor: pointer;

  &::after {
    width: 0;
  }

  &:hover {
    color: ${theme.tabUnderline};
    ${tabUnderLine}

    &::after {
      width: 100%;
      transition: 0.3s;
    }
  }

  &:focus {
    outline: none;
  }

  &[aria-selected='true'] {
    color: ${theme.tabUnderline};
    cursor: default;

    &::after {
      width: 100%;
    }
  }

  &[aria-disabled='true'] {
    color: ${theme.baseDisabled};
    cursor: default;
    pointer-events: none;
  }
`;

export default StyledTab;
